import { TApplication, IResponse } from '@dto';
import { ModuleDefault } from '@modules/default';

export class Read extends ModuleDefault {
  public get<T> (application: TApplication): Promise<IResponse<T>> {
    return this.request.get<IResponse<T>>(`${this.setup.urlBase}/onboarding/${application}`);
  }
}
